export const MOVIMENTO_DEFAULTS = {
    BTN_TEXT_CADASTRAR: 'Cadastrar',
    BTN_TEXT_ATUALIZAR: 'Atualizar',
    TRANSFORMADO_NAO: '0',
    TRANSFORMADO_SIM: '1',
};
